export const PACKAGE_IDS = {
    ALPHAFI_RECEIPT_FIRST_PACKAGE_ID: '0x18533807391b15db5f1f530f54b32553372e5c204d179928d8da0a1753cbb63c',
    ALPHAFI_RECEIPT: '0x8113301d218cbbd1b18e1c60204c87a434af599d13b8d137e77586545ac34b63',
    ALPHA_LATEST: '0xe4848d05267f8775861aeed7bdd37c99b7703a45a7a52a2a03b32a67019fb10f',
};
export const VERSIONS = {
    ALPHA_EMBER: '0xc342914b4f32bad056c137480887b07c519b0f8431ae4e61bb10a6cde1f54f80',
    AUTOBALANCE_LP: '0x80aa0d48c8c5dd7ebaf96c7bec846651eb7e199ff03913edd830e6d00049890d',
    ALPHALEND_VERSION: '0x66b34c1d2d0aa4198e1a2ba172cb4a80d0cfd501a376d5c3782365d0c8282abe',
    ALPHA_NAVI_V2: '0xd912c62a88d526233bf456e77802a5c370cd625e4327c76662e68450b396a797',
    SLUSH: '0x146d1785834528d08a44cac4a59c6a981d43cc13b1d07818e7fa3d29318ca00f',
    SLUSH_LOOP: '0x1140f0b482f22650ab1c51baa9758e4bacba05e5de66dff7ccb1bc60308dbe17',
    MMT: '0x2375a0b1ec12010aaea3b2545acfa2ad34cfbba03ce4b59f4c39e1e25eed1b2a',
    FUNGIBLE_LP: '0x3293f5616005b03c5d7a8ad161aa91c4229ce0df19f61dab1d1d6d0b8f4a1cac',
    LYF_LP: '0xc1619e578f6d6488064babe43c2aee7ae69227d98972a4164107d6d3e9c713cd',
    BLUEFIN_V2: '0x4570f6121c2b5b504d22b061b6461fca8f970eb0bee08a15625d9826bc4e09da',
    STSUI: '0xf62bf937f0f7c3681a14e7f159bb01733749256027b3b3850aafd3de5b27fdfb',
    ALPHA_VERSIONS: {
        1: '0xf9c533b483c656d29aad9b2ee48ea418dde9504fb42c8294298bf523026bf043',
        2: '0xb89716c470af0d16505ff5621e2111f73ac97247c093948660548c3548845aa8',
        3: '0x6f530e5cb2d3c9d73b823f9d394c248513e4e54f5f8cac3b2ca24c3f2bd3ffe7',
        4: '0xdce2e00eadac8928fe6b4d7d3ba33e2cdc3c8b4900fa7c5115bb8f3deee030ee',
        5: '0xa8dce89491194eb551f46c2f9208642147df6e770198641f86891626d008b2a9',
    },
};
export const URLS = {
    COININFO_API: 'https://api.alphalend.xyz/public/graphql',
};
export const POOLS = {
    ALPHA_LEGACY: '0x6ee8f60226edf48772f81e5986994745dae249c2605a5b12de6602ef1b05b0c1',
};
export const IMAGE_URLS = {
    ALPHAFI_RECEIPT: 'https://images.alphafi.xyz/ALPHAFI-POSITION.png',
    SLUSH_POSITION_CAP: 'https://images.alphafi.xyz/ALPHALEND-SLUSH-POSITIONCAP.png',
};
export const STSUI = {
    LST_INFO: '0x1adb343ab351458e151bc392fbf1558b3332467f23bda45ae67cd355a57fd5f5',
};
export const SUI_SYSTEM_STATE = '0x5';
export const CLOCK_PACKAGE_ID = '0x6';
export const ALPHAFI_RECEIPT_WHITELISTED_ADDRESSES = '0x8531b417ed2381501f773d903ca513c4643361ca510c616a63366694f6a84f1e';
export const SLUSH_POSITION_CAP_TYPE = '0x41b1def47b6259cd7306e049d6500eabb1a984e25558b56eefa9b6c000a038c3::alphalend_slush_pool::PositionCap';
// SlushLooping uses a separate contract, so its position cap is a different type.
export const SLUSH_LOOP_POSITION_CAP_TYPE = '0xd1b9ef397179f39002deeb7165674626bc81884025d15fc3efb612c5bc2caaa0::alphalend_slush_pool::PositionCap';
export const ALPHAFI_RECEIPT_TYPE = `${PACKAGE_IDS.ALPHAFI_RECEIPT_FIRST_PACKAGE_ID}::alphafi_receipt::AlphaFiReceipt`;
export const ALPHAFI_TRANSFER_REQUEST_TYPE = `${PACKAGE_IDS.ALPHAFI_RECEIPT}::alphafi_receipt::TransferRequest`;
export const ALPHAFI_TRANSFER_REQUEST_KEY_TYPE = `${PACKAGE_IDS.ALPHAFI_RECEIPT}::alphafi_receipt::TransferRequestKey`;
export const LEGACY_ALPHA_POOL_RECEIPT = '0x9bbd650b8442abb082c20f3bc95a9434a8d47b4bef98b0832dab57c1a8ba7123::alphapool::Receipt';
export const DISTRIBUTOR_OBJECT_ID = '0x33f3c288a90c5368ec3b937875cfae94aebae0ee7fb65e97265728eff9e6995b';
/**
 * Package ids used to *name types* in admin object lookups — not call targets.
 *
 * A Sui type tag carries the id of the package version that first defined the struct (its
 * type-origin entry), and that id never changes on upgrade. So these are upgrade-invariant and
 * must not be replaced with a pool's current `packageId`, nor derived from a neighbouring
 * type/event string: one package can hold types defined across many upgrades (the current slush
 * package `0x8b7c85…` spans six defining ids, e.g. `alphalend_slush_locked_loop_pool` types
 * originate at `0x3221f3…`/`0xad1991…`). Getting one wrong makes the owned-object query return
 * nothing, which surfaces as a bogus "no cap found" permissions error.
 *
 * Values that *do* move on upgrade/redeploy — call-target package ids, pool ids and shared
 * `Version` objects — come from the pool registry (`/public/config`) instead.
 */
export const ADMIN = {
    /** Defines `distributor::RebalanceCap` (original alphapool package). */
    ALPHA_FIRST_PACKAGE_ID: '0x9bbd650b8442abb082c20f3bc95a9434a8d47b4bef98b0832dab57c1a8ba7123',
    /** Defines `alphalend_slush_pool::AdminCap` (slush v1). */
    ALPHA_SLUSH_FIRST_PACKAGE_ID: '0x41b1def47b6259cd7306e049d6500eabb1a984e25558b56eefa9b6c000a038c3',
};
export const GLOBAL_CONFIGS = {
    BLUEFIN: '0x03db251ba509a8d5d8777b6338836082335d93eecbdd09a11e190a1cff51c352',
    CETUS: '0xdaa46292632c3c4d8f31f23ea0f9b36a28ff3677e9684980e4438403a67a3d8f',
    CETUS_REWARDER_GLOBAL_VAULT_ID: '0xce7bceef26d3ad1f6d9b6f13a953f053e6ed3ca77907516481ce99ae8e588f2b',
};
export const ALPHALEND_LENDING_PROTOCOL_ID = '0x01d9cf05d65fa3a9bb7163095139120e3c4e414dfbab153a49779a7d14010b93';
export const ALPHAFI_ORACLE = '0xce4ca140eb264bdc5b03f3268eeb013495f04561e38473aadcf654fb0db6b096';
export const BUCKET_CONFIG = {
    PROTOCOL_ID: '0x9e3dab13212b27f5434416939db5dec6a319d15b89a84fd074d03ece6350d3df',
    FOUNTAIN_ID: '0xbdf91f558c2b61662e5839db600198eda66d502e4c10c4fc5c683f9caca13359',
    FLASK_ID: '0xc6ecc9731e15d182bc0a46ebe1754a779a4bfb165c201102ad51a36838a1a7b8',
};
export const DEEPBOOK_CONFIG = {
    MARGIN_REGISTRY: '0x0e40998b359a9ccbab22a98ed21bd4346abf19158bc7980c8291908086b3a742',
    MARGIN_POOLS: {
        SUI: '0x53041c6f86c4782aabbfc1d4fe234a6d37160310c7ee740c915f0a01b7127344',
        DEEP: '0x1d723c5cd113296868b55208f2ab5a905184950dd59c48eb7345607d6b5e6af7',
        USDC: '0xba473d9ae278f10af75c50a8fa341e9c6a1c087dc91a3f23e8048baf67d0754f',
        WAL: '0x38decd3dbb62bd4723144349bf57bc403b393aee86a51596846a824a1e0c2c01',
        USDSUI: '0x78a0ddd02745d9b500fb7e9aae2ff8b665d974f00fd1f6060d59f4a8e891402c',
    },
};
export const NAVI_CONFIG = {
    NAVI_AGGREGATOR: '0x1fa7566f40f93cdbafd5a029a231e06664219444debb59beec2fe3f19ca08b7e',
    ORACLE_CONFIG: '0x1afe1cb83634f581606cc73c4487ddd8cc39a944b951283af23f7d69d5589478',
    PRICE_ORACLE_ID: '0x1568865ed9a0b5ec414220e8f79b3d04c77acc82358f6e5ae4635687392ffbef',
    SUPRA_ORACLE_HOLDER: '0xaa0315f0748c1f24ddb2b45f7939cff40f7a8104af5ccbc4a1d32f870c0b4105',
    INCENTIVE_V3_ID: '0x62982dad27fb10bb314b3384d5de8d2ac2d72ab2dbeae5d801dbdb9efa816c80',
    INCENTIVE_V2_ID: '0xf87a8acb8b81d14307894d12595541a73f19933f88e1326d5be349c7a6f7559c',
    INCENTIVE_V1_ID: '0xaaf735bf83ff564e1b219a0d644de894ef5bdc4b2250b126b2a46dd002331821',
    NAVI_STORAGE_ID: '0xbb4e2f4b6205c2e2a2db47aeb4f830796ec7c005f88537ee775986639bc442fe',
    HAEDEL_STAKING: '0x47b224762220393057ebf4f70501b6e657c3e56684737568439a04f80849b2ca',
    VOLO: {
        STAKE_POOL: '0x2d914e23d82fedef1b5f56a32d5c64bdcc3087ccfea2b4d6ea51a71f587840e5',
        METADATA: '0x680cd26af32b2bde8d3361e804c53ec1d1cfe24c7f039eb7f549e8dfde389a60',
    },
    KRIYA: {
        VERSION: '0xf5145a7ac345ca8736cf8c76047d00d6d378f30e81be6f6eb557184d9de93c78',
        VSUI_SUI_POOL: '0xf1b6a7534027b83e9093bec35d66224daa75ea221d555c79b499f88c93ea58a9',
    },
    NAVI_POOLS: {
        HASUI: '0x6fd9cb6ebd76bc80340a9443d72ea0ae282ee20e2fd7544f6ffcd2c070d9557a',
        vSUI: '0x9790c2c272e15b6bf9b341eb531ef16bcc8ed2b20dfda25d060bf47f5dd88d01',
        SUI: '0x96df0fce3c471489f4debaaa762cf960b3d97820bd1f3f025ff8190730e958c5',
        USDC: '0xa3582097b4c57630046c0c49a88bfc6b202a3ec0a9db5597c31765f7563755a8',
        USDT: '0x0e060c3b5b8de00fb50511b7a45188c8e34b6995c01f69d98ea5a466fe10d103',
    },
    REWARDS_POOL: {
        NAVX: '0x1a3f9fcfdfac10e92c99220203f7c4bb502558692f0be0f2cb5f788b4e12a6b5',
        DEEP: '0xc889d78b634f954979e80e622a2ae0fece824c0f6d9590044378a2563035f32f',
        vSUI: '0x7093cf7549d5e5b35bfde2177223d1050f71655c7f676a5e610ee70eb4d93b5c',
        stSUI: '0x65a952a1f239c48d8c6fc80de1d3bb248ce6905d1c3897c2ef52948fc7df3616',
    },
    FUNDS_POOLS: {
        vSUI: '0xe2b5ada45273676e0da8ae10f8fe079a7cec3d0f59187d3d20b1549c275b07ea',
        NAVX: '0x9dae0cf104a193217904f88a48ce2cf0221e8cd9073878edd05101d6b771fa09',
    },
    ACCOUNT_ADDRESSES: {
        USDC_USDT_LOOP: '0x522fff4c498a045af792aaf8d74fbad3a63f0ccd269068e661d526bc8a719275',
        SUI_VSUI_LOOP: '0xc2c0f74aa59b2cde7ccb3840c902e40dd09b87f3229e5e4d5f448436ee2d9097',
        HASUI_SUI_LOOP: '0x3d1c9fbaf2b70c1f7f15a903d08d6b5555b6a8a898d5e6abd1b9dbe8741290f9',
        USDT_USDC_LOOP: '0xe13ed1239c70b8ffb56f6925b1b181ed0946429eb6b759519de347706231eae6',
        ALPHALEND_SUI_STSUI_LOOP: '0xc78959333708a02d4b2b1fa46990238ab4fa31321f5abee252d91b3bf3feeaa4',
        suiUSDT: '0x3422136aec9054a8b029d775dff1b39fe2d3938376fb41e6e4b31cbb8a822305',
        NAVX: '0x9181c72e61c9efb247b65c6245b39e80ee3479d30c8f2ae4d053af22302b42a8',
        AUSD: '0x6792adbab0ca3a5eb33174731d740b19aa71a07cbd6c6d2d6f3cc531d82a3c37',
        ETH: '0x7032647d08b61b2bab4fe66242cf9fb5bbf0fe5f180c11eee4a3a8b2a7fdfead',
        NS: '0xa0f5335696fb4ca79db88cc79e0f652b31e764b79e891be1251f2cd834f4bea9',
        stSUI: '0x9f053ed5997f1d68c4cf05ebd1323f926cdd29a2a0489470d9bc0830dc791acd',
        wBTC: '0x21de2ee32a785b60fe7e90a30a1f8634565949755dedf489357fd0dbc6fa2dfb',
        SUI: '0x512bf98e20e137811657e976acee3ca37086d87bc0b0073ffd0f289d0342eccc',
        USDY: '0xbb89a675f772e1780419b0e870fc12982e588f41377a286f239fd8a9843913bd',
        USDC: '0x02bf11dd1e42865a977b219c031483b3c1eda9b862736953443efe30bfda65bd',
        vSUI: '0xe8be7259aaa1ec87c72c77098a271508dcfffb2e0b02abe514928d49a276ba9e',
        WETH: '0xd7565045f34c17890679e28032c5139e09e3a2883a8edb2c45b6ac92e5aabae4',
        // Key must match `poolLabel.asset.name`, which is 'wUSDC' — a 'WUSDC' key silently
        // resolves to undefined and surfaces as a BCS error inside NAVI's SDK.
        wUSDC: '0x57b3a18b87a74fbf26ebda9a5670de6740d587b8009d5d9a31ef589c61b050f0',
        USDT: '0xa7bcc625ed51fd190b87d945f8399f8b28a728a082d9d80d783075d992397746',
        DEEP: '0x6cca5232e4e6a6d34c52ed633215b83cad7445720e76620822bf9287c3f0c708',
        WAL: '0x13bdd7177faa8868bf26090fb67b5f0b1aa4dbd9a021dee9ea20421b496511f9',
    },
    ASSET_MAP: {
        SUI: '0',
        wUSDC: '1',
        USDT: '2',
        WETH: '3',
        CETUS: '4',
        vSUI: '5',
        HASUI: '6',
        USDC: '10',
        USDY: '12',
        AUSD: '9',
        ETH: '11',
        NS: '13',
        NAVX: '7',
        stSUI: '20',
        wBTC: '21',
        suiUSDT: '19',
        DEEP: '15',
        WAL: '24',
    },
    PRICE_FEED: {
        SUI: {
            feedId: '0x2cab9b151ca1721624b09b421cc57d0bb26a1feb5da1f821492204b098ec35c9',
        },
        wUSDC: {
            feedId: '0x70a79226dda5c080378b639d1bb540ddea64761629aa4ad7355d79266d55af61',
        },
        USDC: {
            feedId: '0xe120611435395f144b4bcc4466a00b6b26d7a27318f96e148648852a9dd6b31c',
        },
        USDT: {
            feedId: '0xf72d8933873bb4e5bfa1edbfa9ff6443ec5fac25c1d99ba2ef37f50a125826f3',
        },
        WETH: {
            feedId: '0x44d92366eba1f1652ec81f34585406726bef267565a2db1664ffd5ef18e21693',
        },
        CETUS: {
            feedId: '0x5ac98fc1e6723af2a6d9a68a5d771654a6043f9c4d2b836b2d5fb4832a3be4f2',
        },
        NAVX: {
            feedId: '0x4324c797d2f19eff517c24adec8b92aa2d282e44f3a5cafb36d6c4b30d7f2dca',
        },
        WBTC: {
            feedId: '0x1bf4727242a61d892feef6616d3e40a3bd24b64b5deb884054e86cb9360556c4',
        },
        AUSD: {
            feedId: '0x9a0656e1e10a0cdf3f03dce9db9ad931f51dc6eac2e52ebfbf535dfbcf8100ef',
        },
        ETH: {
            feedId: '0x9a6ffc707270286e98e8d0f654ce38f69efbc302ac98e2deb11fbad2211600f0',
        },
        USDY: {
            feedId: '0x11ddf2ac1868d493e2487deeb2a0c2791bb7ca69632c8c5fefe85e09390be093',
        },
        NS: {
            feedId: '0xc771ec0ca245857f30195ce05197a7b3ab41c58c1e8abe0661919d90675ad63d',
        },
        DEEP: {
            feedId: '0x4558092b08ad1b33b0eb536f91a4655693c2390ac568f06de6f6fad827888600',
        },
        BLUE: {
            feedId: '0xd8286c11df7e49496ee75622ae4132c56385c30b4bedb392e36c0699a52a1d52',
        },
        BUCK: {
            feedId: '0x93c1b815f64ef7c4311d74ff7c0ca1e47739c3ac31fdee0068c30887633ba2fb',
        },
        suiUSDT: {
            feedId: '0xdeba21105ff41300f8829aaeba45fdec25d1533a64d504ef0348ff005da3fbe5',
        },
        stSUI: {
            feedId: '0xd7a8c920db9f8b5c3c300307d88fca53684fd15b760977dbf8f0adc6e55783bd',
        },
        wBTC: {
            feedId: '0x4e4666c82c476f0b51b27c5ed8c77ab960aa5e4c3a48796e179d721b471e3b7e',
        },
        vSUI: {
            feedId: '0x086bb5540047b3c77ae5e2f9b811c7ef085517a73510f776753c8ee83d19e62c',
        },
        HASUI: {
            feedId: '0xac934a2a2d406085e7f73b460221fe1b11935864605ba58cdbb8e21c15f12acd',
        },
    },
};
export const BLUEFIN_STRATEGY_PACKAGE_ID = '0xd075338d105482f1527cbfd363d6413558f184dec36d9138a70261e87f486e9c';
export const CETUS_STRATEGY_PACKAGE_ID = '0x1eabed72c53feb3805120a081dc15963c204dc8d091542592abaf7a35689b2fb';
export const ALPHAFI_SWAPPER_PACKAGE_ID = '0x6bf7fe0f664a5607a2f871ab9ddb824e8a1b22b77b2e60fce382c6cee71c86b9';
export const Cetus_math_package_id = '0xdfaadf86be9af246900d1e3f3b996cf549e7948e662a9977bdd7646d8fa3a778';
// ============================================================
// Cache TTLs (milliseconds)
// ============================================================
export const CACHE_TTL = (() => {
    const DEFAULT = 5 * 60 * 1000;
    return {
        DEFAULT,
        STRATEGY_CACHE: DEFAULT, // 5 minutes
        ALPHALEND_MARKETS: 60 * 1000, // 60 seconds
        APR_DATA: 10 * 60 * 1000, // 10 minutes - APR changes frequently
        POOL_LABELS: DEFAULT, // 5 minutes - config rarely changes
        TVL_DATA: 10 * 60 * 1000, // 10 minutes - TVL changes moderately
        DISTRIBUTOR: 10 * 60 * 1000, // 10 minutes - for accurate reward calculation
        USER_DATA: DEFAULT, // 5 minutes - user positions can change
        COIN_INFO: DEFAULT, // 5 minutes - coin info is stable
    };
})();
//# sourceMappingURL=constants.js.map